import React, { useState, useEffect, useMemo, memo } from "react"
import { makeStyles } from "@material-ui/core/styles"
import Box from "@material-ui/core/Box"
import { fetchManagerUserList } from "@/redux/actions/userListAction"
import { useDispatch, useSelector } from "react-redux"
import Loading from "@/components/common/Loading"
import StickyHeadTable from "@/components/common/StickyHeadTable"

const useStyles = makeStyles((theme) => ({
    wrapper: {
        padding: theme.spacing(3),
    },
}))

const ViewManagerTable = memo((props) => {
    const { userCompanyId } = props
    const classes = useStyles()
    const [columns] = useState(() => [
        { id: "firstName", label: "First name", minWidth: 130 },
        { id: "lastName", label: "Last name", minWidth: 130 },
        { id: "email", label: "Email", minWidth: 130 },
    ])

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchManagerUserList(userCompanyId))
    }, [userCompanyId])

    const { loading, userList: listInit, error } = useSelector((state) => state.userListReducer)

    const list = useMemo(() => listInit.map((item) => ({ ...item, id: item.userId })), [listInit])

    return (
        <>
            {loading ? (
                <Loading />
            ) : (
                <>
                    {error ? (
                        <div>Error</div>
                    ) : (
                        <Box mt={1} className={classes.participantNoRoleListTableWrapper}>
                            <StickyHeadTable columns={columns} rows={list} tableTitle="Current Projects Manager" />
                        </Box>
                    )}
                </>
            )}
        </>
    )
})

export default ViewManagerTable
